export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/heartbeat.worker.c214bcc0.worker.js");
}
